import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export const ModalButtons = ({ className, children, theme, ...rest }) => (
    <div
        className={ classnames({
            [theme.buttons]: true,
            [className]: !!className,
        }) }
        { ...rest }
    >
        { children }
    </div>
);

ModalButtons.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    theme: PropTypes.shape({}),
};

export default ModalButtons;
